var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play-button"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?[_c('v-loader',{attrs:{"white":""}})]:[_c('v-icon',{attrs:{"icon":"play_arrow","size":"2.75rem"}})]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }